import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetMaterialLegacyIdForBlenderConnectorQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type GetMaterialLegacyIdForBlenderConnectorQuery = { __typename: 'Query', materialRevision: { __typename: 'MaterialRevision', material: { __typename: 'Material', id: string, legacyId: number, name?: string | null, latestCyclesRevision?: { __typename: 'MaterialRevision', legacyId: number } | null } } };

export type MaterialRevisionForBlenderQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type MaterialRevisionForBlenderQuery = { __typename: 'Query', materialRevision: { __typename: 'MaterialRevision', id: string, material: { __typename: 'Material', legacyId: number, name?: string | null, organization?: { __typename: 'Organization', name?: string | null } | null }, exchangeNodesAndConnections: { __typename: 'ExchangeNodesAndConnections', nodes: Array<{ __typename: 'ExchangeNode', id: string, name: string, parameters: any, textureSetRevisionId?: string | null, textureRevisionId?: string | null }>, connections: Array<{ __typename: 'ExchangeConnection', sourceId: string, sourceParameter: string, destinationId: string, destinationParameter: string }> } } };

export type TextureRevisionForBlenderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TextureRevisionForBlenderQuery = { __typename: 'Query', textureRevision: { __typename: 'TextureRevision', id: string, width: number, height: number, displacement?: number | null, number?: number | null, dataObject: { __typename: 'DataObject', id: string, originalFileName: string, downloadUrl: string, imageColorSpace?: Types.ImageColorSpace | null }, texture?: { __typename: 'Texture', type: Types.TextureType, textureSet: { __typename: 'TextureSet', legacyId: number, name?: string | null, textureGroup: { __typename: 'TextureGroup', legacyId: number, name?: string | null } } } | null } };

export type TextureSetRevisionForBlenderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TextureSetRevisionForBlenderQuery = { __typename: 'Query', textureSetRevision: { __typename: 'TextureSetRevision', id: string, name?: string | null, width: number, height: number, displacement?: number | null, textureSet: { __typename: 'TextureSet', legacyId: number, textureSetRevisions: Array<{ __typename: 'TextureSetRevision', id: string }> }, mapAssignments: Array<{ __typename: 'TextureSetRevisionMapAssignment', textureType: Types.TextureType, dataObject: { __typename: 'DataObject', id: string, originalFileName: string, downloadUrl: string, imageColorSpace?: Types.ImageColorSpace | null } }> } };

export type ExchangeNodesAndConnectionsForBlenderQueryVariables = Types.Exact<{
  graphNode: Types.Scalars['JsonObject']['input'];
}>;


export type ExchangeNodesAndConnectionsForBlenderQuery = { __typename: 'Query', exchangeNodesAndConnectionsForGraphNode: { __typename: 'ExchangeNodesAndConnections', nodes: Array<{ __typename: 'ExchangeNode', id: string, name: string, parameters: any, textureSetRevisionId?: string | null, textureRevisionId?: string | null }>, connections: Array<{ __typename: 'ExchangeConnection', sourceId: string, sourceParameter: string, destinationId: string, destinationParameter: string }> } };

export type DataObjectForBlenderQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type DataObjectForBlenderQuery = { __typename: 'Query', dataObject: { __typename: 'DataObject', id: string, legacyId: number, originalFileName: string, downloadUrl: string, imageColorSpace?: Types.ImageColorSpace | null } };

export type HdriForBlenderQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type HdriForBlenderQuery = { __typename: 'Query', hdri: { __typename: 'Hdri', legacyId: number, name?: string | null, dataObject?: { __typename: 'DataObject', id: string, originalFileName: string, downloadUrl: string } | null } };

export const GetMaterialLegacyIdForBlenderConnectorDocument = gql`
    query getMaterialLegacyIdForBlenderConnector($legacyId: Int!) {
  materialRevision(legacyId: $legacyId) {
    material {
      id
      legacyId
      name
      latestCyclesRevision {
        legacyId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialLegacyIdForBlenderConnectorGQL extends Apollo.Query<GetMaterialLegacyIdForBlenderConnectorQuery, GetMaterialLegacyIdForBlenderConnectorQueryVariables> {
    override document = GetMaterialLegacyIdForBlenderConnectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialRevisionForBlenderDocument = gql`
    query materialRevisionForBlender($legacyId: Int!) {
  materialRevision(legacyId: $legacyId) {
    id
    material {
      legacyId
      name
      organization {
        name
      }
    }
    exchangeNodesAndConnections {
      nodes {
        id
        name
        parameters
        textureSetRevisionId
        textureRevisionId
      }
      connections {
        sourceId
        sourceParameter
        destinationId
        destinationParameter
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialRevisionForBlenderGQL extends Apollo.Query<MaterialRevisionForBlenderQuery, MaterialRevisionForBlenderQueryVariables> {
    override document = MaterialRevisionForBlenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TextureRevisionForBlenderDocument = gql`
    query textureRevisionForBlender($id: ID!) {
  textureRevision(id: $id) {
    id
    width
    height
    displacement
    number
    dataObject {
      id
      originalFileName
      downloadUrl
      imageColorSpace
    }
    texture {
      type
      textureSet {
        legacyId
        name
        textureGroup {
          legacyId
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TextureRevisionForBlenderGQL extends Apollo.Query<TextureRevisionForBlenderQuery, TextureRevisionForBlenderQueryVariables> {
    override document = TextureRevisionForBlenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TextureSetRevisionForBlenderDocument = gql`
    query textureSetRevisionForBlender($id: ID!) {
  textureSetRevision(id: $id) {
    id
    textureSet {
      legacyId
      textureSetRevisions {
        id
      }
    }
    name
    width
    height
    displacement
    mapAssignments {
      textureType
      dataObject {
        id
        originalFileName
        downloadUrl
        imageColorSpace
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TextureSetRevisionForBlenderGQL extends Apollo.Query<TextureSetRevisionForBlenderQuery, TextureSetRevisionForBlenderQueryVariables> {
    override document = TextureSetRevisionForBlenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExchangeNodesAndConnectionsForBlenderDocument = gql`
    query exchangeNodesAndConnectionsForBlender($graphNode: JsonObject!) {
  exchangeNodesAndConnectionsForGraphNode(graphNode: $graphNode) {
    nodes {
      id
      name
      parameters
      textureSetRevisionId
      textureRevisionId
    }
    connections {
      sourceId
      sourceParameter
      destinationId
      destinationParameter
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExchangeNodesAndConnectionsForBlenderGQL extends Apollo.Query<ExchangeNodesAndConnectionsForBlenderQuery, ExchangeNodesAndConnectionsForBlenderQueryVariables> {
    override document = ExchangeNodesAndConnectionsForBlenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DataObjectForBlenderDocument = gql`
    query dataObjectForBlender($legacyId: Int!) {
  dataObject(legacyId: $legacyId) {
    id
    legacyId
    originalFileName
    downloadUrl
    imageColorSpace
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DataObjectForBlenderGQL extends Apollo.Query<DataObjectForBlenderQuery, DataObjectForBlenderQueryVariables> {
    override document = DataObjectForBlenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HdriForBlenderDocument = gql`
    query hdriForBlender($legacyId: Int!) {
  hdri(legacyId: $legacyId) {
    legacyId
    name
    dataObject {
      id
      originalFileName
      downloadUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HdriForBlenderGQL extends Apollo.Query<HdriForBlenderQuery, HdriForBlenderQueryVariables> {
    override document = HdriForBlenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }